import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Global } from 'src/app/core/resources/global';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SnackBarService } from 'src/app/core/services/snackBar.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DriverCargoService } from './driver-cargo.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Cargo } from 'src/app/core/interfaces/cargo';
import { AngularFireStorage } from '@angular/fire/storage';
import { Utils } from 'src/app/core/resources/utils';
import * as _ from 'lodash';
import { FileStorage } from 'src/app/core/interfaces/fileStorage';
import { AccountService } from '../../account/account.service';
import { User } from 'src/app/core/interfaces/user';
import { VehiclesService } from '../../administration/vehicles/list-vehicles.service';
import { Vehicle } from 'src/app/core/interfaces/vehicle';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserFormComponent } from '../../administration/admin-users/user-form/user-form.component';
import { AdminUsersService } from '../../administration/admin-users/admin-users.service';
import { DetailVehicleComponent } from '../../administration/vehicles/detail-vehicle/detail-vehicle.component';
import { InformationUser } from 'src/app/core/interfaces/informationUser';
import { Dialog } from 'src/app/core/resources/dialog';
import { DialogSurveyComponent } from 'src/app/shared/dialog-survey/dialog-survey.component';
import { CargoItemService } from '../cargo-item/cargo-item.service';
import { environment } from 'src/environments/environment';
import { OpenDetailManifestsComponent } from '../open-detail-manifests/open-detail-manifests.component';
import { ContainerChecklistComponent } from '../container-checklist/container-checklist.component';
import * as firebase from 'firebase/app';
import 'firebase/storage';
import { ModalEnum } from 'src/app/core/enums/modal.enum';
import { ChangeDriverComponent } from '../change-driver/change-driver.component';
import { Permission } from 'src/app/core/resources/permission';
import { UserManager } from 'src/app/core/managers/user.manager';
import { Roles } from 'src/app/core/enums/roles.enum';
import { PermissionRole } from 'src/app/core/resources/permission-role';
import { Companies } from 'src/app/core/resources/companies';
import { CargoManager } from 'src/app/core/managers/cargo.manager';
import { TRIP_TYPES } from 'src/app/core/enums/tripTypes.enum';
import { FormMessages } from 'src/app/core/messages/form-messages.enum';
import { ServiceMessages } from 'src/app/core/messages/service-messages.enum';
import { ContainerInspect } from 'src/app/core/interfaces/container-inspect';
import { VehicleInspect } from 'src/app/core/interfaces/vehicleInspect';

@Component({
  selector: 'app-driver-cargo',
  templateUrl: './driver-cargo.component.html',
  styleUrls: ['./driver-cargo.component.scss'],
  providers: [AuthService, Global, DriverCargoService, UserManager]
})

export class DriverCargoComponent implements OnInit {
  // Inputs
  @Input() cargo: Cargo;
  @Input() expireArl: boolean = false;
  @Input() expireEps: boolean = false;
  @Input() driver?: User;
  @Input() owner?: User;
  @Input() onlyDriver: boolean;
  @Input() isNegotiation: boolean;
  @Input() idVehicle?: string;
  @Input() vehicle?: Vehicle;
  @Input() vehicleAll?: Vehicle;
  @Input() administrator?: InformationUser;
  @Input() secondDriver?: User;
  // Outputs
  @Output() emitDriver: EventEmitter<any> = new EventEmitter();
  @Output() emitVehicle: EventEmitter<any> = new EventEmitter();
  @Output() containerInspectionSaved: EventEmitter<any> = new EventEmitter();
  @Output() emitNotOwner: EventEmitter<any> = new EventEmitter();
  @Output() refreshLoad: EventEmitter<string> = new EventEmitter();
  public lastInspection: VehicleInspect;
  public lastContainerInspection: ContainerInspect;
  public environment = environment;
  public trailer = null;
  instanceLogo: FileStorage;
  basePath: string;
  photo: string;
  userActive = this.authService.getUserSession().information;
  haveVehicle: Vehicle;
  permission = Permission;
  constructor(
    public authService: AuthService,
    private spinner: NgxSpinnerService,
    private snackBarService: SnackBarService,
    private service: DriverCargoService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private angularFireStorage: AngularFireStorage,
    public utils: Utils,
    private accountService: AccountService,
    public vehiclesService: VehiclesService,
    public dialog: MatDialog,
    public adminUserService: AdminUsersService,
    private dialogUtils: Dialog,
    private storage: AngularFireStorage,
    public cargoItemService: CargoItemService,
    private userManager: UserManager,
    public permissionRole: PermissionRole,
    private cargoManager: CargoManager
  ) {

  }

  ngOnInit() {
    this.haveVehicle = this.vehicleAll;
    this.getURlPictureDrivers();
    this.getDetailVehicle('inspection');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.driver && changes.driver.currentValue && changes.driver.currentValue.profilePicture) {
      this.getURlPictureDrivers();
    }
    if (changes && changes.secondDriver && changes.secondDriver.currentValue && changes.secondDriver.currentValue.profilePicture) {
      this.getURlPictureDrivers('secondDriver');
    }
  }

  getDetailDriver(idDriver: string, type: string = 'driver') {
    this.accountService.validateEntity(1, idDriver).subscribe(
      (data: User) => {
        if (this.utils.isDefined(data)) {
          this[type] = this.userManager.sanitizeUser(data, Roles.DRIVER);
          this.emitDriver.emit({ data, type });
        } else {
          this.setDefaultDriver(type);
        }
      },
      (error) => {
        this.setDefaultDriver(type);
      }
    );
  }

  getURlPictureDrivers(typeDriver: string = 'driver') {
    const storage = AuthService.fStorage;
    if (this.utils.isDefined(this[typeDriver]) && this.utils.isDefined(this[typeDriver].profilePicture)) {
      const pathReference = storage.ref(this[typeDriver].profilePicture);
      pathReference.getDownloadURL().then(
        (data) => {
          this[typeDriver].profilePictureUrl = data;
        },
        (error) => {
          this[typeDriver].profilePictureUrl = null;
        }
      );
    }
  }

  setDefaultDriver(type: string = 'driver') {
    this[type] = {
      information: {
        document: this.cargo.driver
      }
    };
  }

  setInstanceFileStorage(e: Event) {

    if (this.utils.isImage(e.target['files'])) {
      this.instanceLogo = {
        fileData: {
          file: e.target['files'][0],
          name: e.target['files'][0]['name'],
          uploaded: true,
          size: this.utils.bytesToSize(e.target['files'][0].size),
          url: null
        },
        storageData: {
          storageRef: null,
          uploadTask: null,
          uploadProgress: null
        }
      };
      this.uploadFileStorage();
    } else {
      this.snackBarService.openSnackBar('El archivo no es una imagen', undefined, 'error')
    }

  }

  uploadFileStorage() {
    this.basePath = 'driver/' + this.driver.information.document + '/';
    const filePath = this.basePath + 'profile.jpg'
    this.instanceLogo.storageData.storageRef = this.angularFireStorage.ref(filePath);
    this.instanceLogo.storageData.uploadTask = this.angularFireStorage.upload(filePath, this.instanceLogo.fileData.file);

  }

  get hasTransportServicesCompany(): boolean {
    return this.authService && this.authService.hasTransportServicesCompany;
  }

  getPreviewImage(e: Event) {
    this.utils.getImageBase64(e.target['files'][0])
      .then((url: string) => {
        this.photo = url;
      })
      .catch((error) => {
        console.error(error);
      });
  }


  getDetailVehicle(action?) {
    if (this.cargo && this.utils.isDefined(this.cargo.licensePlate)) {
      this.vehiclesService.getVehicleFromOwnCompany(this.cargo.licensePlate).subscribe(
        (success: any) => {
          if (success) {
            this.vehicle = success;

            if (!!this.vehicle.trailerId) {
              this.vehiclesService
                .getTrailerList(`?id=${this.vehicle.trailerId}`)
                .subscribe(
                  (trailers: any[]) => {
                    if (Array.isArray(trailers)) {
                      this.trailer = trailers[0];
                    }
                  }
                );
            }

            if (action === "emit") {
              this.emitVehicle.emit(success);
            }
            if (action === "inspection") {
              this.getInspect();
            }
          } else {
            this.vehicle = null;
          }
        },
        (error) => {
          this.vehicle = null;
        }
      );
    } else {
      this.vehicle = null;
    }
  }

  get scoreDriver() {
    try {
      return Array(Math.round(this.driver.teclogiScore.globalScore)).fill(0).map((x, i) => i);
    } catch (e) {
      return 0;
    }
  }

  openDetailDriver(driver: User, type: string = 'driver') {
    if (!this.showDriverDetail) return;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      driver: driver,
      expireArl: this.expireArl,
      expireEps: this.expireEps
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(UserFormComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.getDetailDriver(driver.information.document, type);
    });
  }

  openDetailVehicle() {
    if (!this.showVehicleDetail) return;
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      vehicle: this.vehicle
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.LARGE_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    const dialogRef = this.dialog.open(DetailVehicleComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.state) {
        this.getDetailVehicle('emit');
      }
    });
  }

  checkValidateVehicle() {
    const vehicleDetail = this.utils.clone(this.vehicle);
    this.spinner.show();
    this.adminUserService.checkValidationVehicle(vehicleDetail.id, false).toPromise()
      .then((success: any) => {
        this.snackBarService.openSnackBar('Validación en proceso', undefined, 'success');
      })
      .catch((error) => {
        this.snackBarService.openSnackBar('Ocurrio un error en la validacion', undefined, 'error');

      })
      .finally(() => {
        this.getDetailDriver(this.driver.information.document);
        this.spinner.hide();
      });

  }



  checkOpenDetailAction($event: boolean, driver: User, type: string = 'driver') {
    $event && this.openDetailDriver(driver, type);
  }

  checkValidationUser(driver: User, type: string = 'driver') {
    const driverDetail: User = this.utils.clone(driver);
    delete driverDetail.profilePictureUrl;
    if (driverDetail && driverDetail.information && driverDetail.information.document) {
      this.spinner.show();
      const $sub = this.adminUserService.checkValidationUser(driverDetail.information.document).subscribe(
        {
          next: async (success: { driver: User }) => {
            const driver = success && success.driver ? success.driver : null;
            const { active, errors } = await this.adminUserService.isEnabledByValidationRules(driver, 'Driver');
            let documentsToValidate = errors
              .filter(error => /arl|eps/i.test(error))
              .map(error => error.toLowerCase().includes('arl') ? 'arl' : 'eps');

            const driverDescription = this.utils.getNestedValue(driver, 'state.description');
            if (!driver)
              this.snackBarService.openSnackBar(ServiceMessages.GENERAL_HTTP_ERROR, undefined, 'error');
            else if (driverDescription === 'Pending')
              this.snackBarService.openSnackBar(FormMessages.VALIDATION_USER, undefined, 'alert');
            else if (!active)
              this.adminUserService.confirmDriverInactive(driver, this.vehicle, documentsToValidate);
            this.getDetailDriver(driver.information.document, type);
            this.spinner.hide();
          },
          error: () => {
            this.snackBarService.openSnackBar('Ocurrió un error con la petición', undefined, 'error');
            this.getDetailDriver(driver.information.document, type);
            this.spinner.hide();
          },
          complete: () => {
            $sub.unsubscribe();
          }
        }
      )
    } else {
      this.snackBarService.openSnackBar('No fue posible acceder al documento del usuario', undefined, 'error');
      this.getDetailDriver(driver.information.document, type);
    }
  }

  changeDriver() {
    if (this.haveVehicle && this.haveVehicle.owner === undefined) {
      this.emitNotOwner.emit(true);
    } else {
      const formControl = new FormControl();
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = {
        title: 'Modificación de conductor',
        label: 'Ingresa el número de documento',
        idVehicle: this.idVehicle,
        options: {
          typeUser: 'driver',
        },
        inputFormControl: formControl
      };
      dialogConfig.width = ModalEnum.EXTRA_SMALL_WIDTH;
      dialogConfig.autoFocus = false;
      dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
      const modalDialog = this.dialog.open(ChangeDriverComponent, dialogConfig);
      modalDialog.afterClosed().subscribe(result => {
        if (result && result.state && result.data) {
          this.vehicleChangeDriver(result.data, result.securityStudyValidation);
        }
      });
    }
  }

  vehicleChangeDriver(user: User, securityStudyValidation: boolean) {
    this.spinner.show();
    this.vehiclesService.vehicleChangeDriver(this.idVehicle, user, securityStudyValidation).toPromise()
      .then((success: User) => {
        if (success) {
          if (success.errorRNDC && success.errorRNDC && success.errorRNDC.error === 'Debe ingresar un conductor diferente al actual') {
            this.snackBarService.openSnackBar('Debe ingresar un conductor diferente al actual', undefined, 'alert');
          } else {
            this.snackBarService.openSnackBar('Conductor asignado correctamente');
            this.getDetailDriver(this.driver.information.document);
          }
        } else {
          this.snackBarService.openSnackBar('Ocurrió un error al cambiar de conductor', undefined, 'error');
        }
      })
      .catch((error) => {
        this.snackBarService.openSnackBar('Ocurrió un error al cambiar de conductor', undefined, 'error');
      })
      .finally(() => {
        this.spinner.hide();
      });
  }

  public getInspect() {
    if (this.cargo && this.cargo.vehicleInspection) {
      this.cargoItemService.getInspection(this.cargo.vehicleInspection, "vehicle").subscribe(res => {
        this.lastInspection = res as VehicleInspect;
      }, (error) => {
        console.error(error);
      });
    }

    if (this.cargo && (this.cargo.trailerInspection || this.cargo.containerInspectionId)) {
      const containerInspection = this.cargo ? this.cargo.containerInspectionId ? this.cargo.containerInspectionId : this.cargo.trailerInspection : null;
      this.cargoItemService.getInspection(containerInspection, "container").subscribe(res => {
        this.lastContainerInspection = res as ContainerInspect;
      }, (error) => {
        console.error(error);
      });
    }
  }

  public async createInspection() {
    this.cargoManager.checkInspection(this.cargo, this.authService.getUserSession().information, this.cargo.licensePlate)
      .then((state) => {
        if (state) {
          this.containerInspectionSaved.emit(this.cargo.consecutive);
          this.getDetailVehicle('inspection');
        }
      }).catch(() => { });
  }

  public openInspectionVehicle() {
    if (!this.lastInspection) return this.snackBarService.openSnackBar(FormMessages.MISSING_INSPECTION, undefined, 'error');
    const typeOfInspection: 'form' | 'document' = this.lastInspection.inspectionDocument ? 'document' : 'form';
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      inspect: this.lastInspection,
      disabled: true,
      user: this.userActive,
      licensePlate: this.vehicle.id,
      id: this.cargo.id,
      cargo: this.cargo,
      typeOfInspection
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    this.dialog.open(DialogSurveyComponent, dialogConfig).afterClosed().subscribe(() => {
      this.getDetailVehicle('inspection');
    });
  }

  public openManifests() {
    const dialogConfig = new MatDialogConfig();
    const title = `Manifiestos asociados`;
    dialogConfig.data = {
      title: title,
      manifest: this.driver.manifests,
      driverName: this.driver.information.name
    };
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.autoFocus = false;
    this.dialog.open(OpenDetailManifestsComponent, dialogConfig);
  }

  public get showContainerChecklist(): boolean {
    if (!this.hasTransportServicesCompany) return false;
    if (this.cargo && (this.cargo.trailerInspection || this.cargo.containerInspectionId)) return true;
    return this.utils.requestContainerInspection(this.cargo, this.vehicle);
  }

  public async openContainerChecklist() {
    const hasInspection = this.cargo.trailerInspection || this.cargo.containerInspectionId;
    let typeOfInspection: 'form' | 'document' = 'form';
    if (!hasInspection) { //El servicio no tiene inspección de contenedor
      typeOfInspection = await this.cargoManager.modalTypeOfInspection('container');
      if (!typeOfInspection) return;
    } else if (!this.lastContainerInspection) //El servicio tiene inspección de contenedor pero no fue posible cargarla
      return this.snackBarService.openSnackBar(FormMessages.MISSING_INSPECTION, undefined, 'error');
    else if (this.lastContainerInspection.inspectionDocument) //El servicio tiene inspección de contenedor y es de tipo documento
      typeOfInspection = 'document';
    if (!this.cargo.container && !(this.cargo.containers && this.cargo.containers.length))
      this.snackBarService.openSnackBar("Recuerde ingresar el número de contenedor en el servicio", undefined, 'info');
    const dialogConfig = new MatDialogConfig();
    const title = `Inspección a las unidades de carga`;
    dialogConfig.data = {
      title: title,
      driverName: this.driver.information.name,
      user: this.userActive,
      licensePlate: this.vehicle.id,
      disabled: false,
      cargoId: this.cargo.id,
      cargoContainer: this.cargo.container
        || (this.cargo.containers && this.cargo.containers.length ? this.cargo.containers[0] : ''),
      inspect: this.lastContainerInspection,
      type: typeOfInspection,
    };
    dialogConfig.maxHeight = ModalEnum.MAX_HEIGHT;
    dialogConfig.width = ModalEnum.MEDIUM_WIDTH;
    dialogConfig.maxWidth = ModalEnum.MAX_WIDTH;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(ContainerChecklistComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {
      this.containerInspectionSaved.emit(this.cargo.consecutive);
      this.getDetailVehicle('inspection');
    });
  }

  get showVehicleDetail(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.readVehicleDetails);
  }

  get showDriverDetail(): boolean {
    return this.permissionRole.hasPermission(this.permission.cargo.module, this.permission.cargo.readDriverDetails);
  }
}
